import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
// @src imports
import { getGifts, GiftFragment } from 'src/graphql'
import suspenseBoundary from 'src/chrome/SuspenseBoundary/suspenseBoundaryHOC'

import GiftTiles from '../GiftTiles/GiftTiles'
import MoreIcon from '../MoreIcon/MoreIcon'
import NotFound from '../NotFound/NotFound'
import styles from './giftRibbon.module.scss'
import { Text } from '@sendoutcards/quantum-design-ui'

interface Props {
  id?: number
  name: string
  categoryId?: string
  shouldWrapContent?: boolean
  viewGift: (slug: string) => void
  addGift: (gift: GiftFragment) => void
  giftLimit?: number
  search?: string
  onSelect?: () => void
}

const GiftRibbon: React.FC<Props> = props => {
  const {
    onSelect,
    id,
    addGift,
    categoryId,
    name,
    giftLimit = 20,
    shouldWrapContent,
    viewGift,
    search,
  } = props

  const giftsQuery = getGifts({
    category: categoryId,
    offset: 0,
    limit: giftLimit,
    search,
  })

  return (
    <div
      className={`${styles.GiftRibbon} ${
        shouldWrapContent && styles.gridPadding
      }`}
    >
      <div className={styles.ribbonInfo}>
        <div onClick={() => onSelect?.()} style={{ cursor: 'pointer' }}>
          <Text type="largeBody" color="primaryHeading">
            {name}
          </Text>
        </div>
        {!shouldWrapContent && (
          <MoreIcon onClick={onSelect} giftsQuery={giftsQuery} />
        )}
      </div>
      <NotFound giftsQuery={giftsQuery} />
      <div
        className={styles.ribbonCards}
        style={
          shouldWrapContent
            ? { flexWrap: 'wrap', justifyContent: 'center' }
            : {}
        }
      >
        <GiftTiles
          id={id}
          viewGift={viewGift}
          addGift={addGift}
          giftsQuery={giftsQuery}
        />
      </div>
    </div>
  )
}

const Unresolved = () => (
  <div style={{ background: 'transparent', boxShadow: 'none' }}>
    <CircularProgress />
  </div>
)

export default suspenseBoundary({
  component: GiftRibbon,
  failure: error => `Failed loading gifts: ${error}`,
  unresolved: <Unresolved />,
})
